<template>
    <v-card class="mx-auto" shaped elevation="7" min-height="700px">
        <v-card-title>
            Informe De Siniestro
        </v-card-title>
        <v-card-text>
            <v-container fluid grid-list-md>
                <v-row dense>
                    <v-col cols="12" sm="12">
                        <ModalInformeSiniestroComponent :open="obModal.open" 
                                                        :obModal="obModal" 
                                                        :listDocumentos="listDocumentos" 
                                                        :parametros="parametros"/>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="4">
                        <v-dialog ref="fechaDesde" v-model="obDate.open1" :return-value.sync="obSearch.fechaDesde" persistent
                            width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field color="textbox" v-model="obSearch.fechaDesde"
                                    label="Fecha Desde *" :rules="requeridoRegla" prepend-inner-icon="event"
                                    readonly outlined dense v-on="on" />
                            </template>
                            <v-date-picker color="primary" v-model="obSearch.fechaDesde" scrollable locale="es">
                                <v-spacer></v-spacer>
                                <v-btn outlined dense rounded @click="obDate.open1 = false" v-html="'Salir'">
                                </v-btn>
                                <v-btn rounded dark color="primary" @click="$refs.fechaDesde.save(obSearch.fechaDesde)"
                                    v-html="'Guardar Fecha'">
                                </v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-dialog ref="fechaHasta" v-model="obDate.open2" :return-value.sync="obSearch.fechaHasta" persistent
                            width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field color="textbox" v-model="obSearch.fechaHasta"
                                    label="Fecha Hasta *" :rules="requeridoRegla" prepend-inner-icon="event"
                                    readonly outlined dense v-on="on" />
                            </template>
                            <v-date-picker color="primary" v-model="obSearch.fechaHasta" scrollable locale="es">
                                <v-spacer></v-spacer>
                                <v-btn outlined dense rounded @click="obDate.open2 = false" v-html="'Salir'">
                                </v-btn>
                                <v-btn rounded dark color="primary" @click="$refs.fechaHasta.save(obSearch.fechaHasta)"
                                    v-html="'Guardar Fecha'">
                                </v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Estado Siniestro *" color="textbox" v-model="obSearch.idEstadoSiniestro"
                                :items="listGeneral.listEstadoSiniestro" item-text="estadoSiniestro" item-value="idEstadoSiniestro" outlined
                                dense :rules="requeridoRegla" />
                    </v-col>
                </v-row>

                <v-row dense>
                    <v-col cols="12" sm="4">
                        <v-text-field label="N° Documento " color="textbox" v-model="obSearch.nroDocumento"
                                dense outlined :rules="_.size(obSearch.nroDocumento) > 0 ? numeroRegla : []" />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field label="Nombres " color="textbox" v-model="obSearch.nombres"
                                dense outlined :rules="_.size(obSearch.nombres) > 0 ? letrasRegla : []" />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-tooltip top color="primary">
                                <template v-slot:activator="{ on }">
                                    <v-btn fab dark small color="primary" @click="onListar" v-on="on"
                                            :disabled="disabled">
                                            <v-icon dark>search</v-icon>
                                    </v-btn>
                                </template>
                                <span>Buscar</span>
                        </v-tooltip>
                    </v-col>
                </v-row>

                <v-row dense>
                    <v-col v-if="_.size(listGeneral.listDetalle) == 0" cols="12" sm="6"/>
                    <v-col v-else cols="12" sm="6">
                        <v-btn rounded color="primary" dark @click="exportar('tableInf','Informe de Siniestro')">Exportar a XLSX</v-btn>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field label="Buscar" color="textbox" v-model="obSearch.search" clearable dense
                            prepend-inner-icon="search" />
                    </v-col>
                </v-row>

                <v-row dense>
                    <v-col cols="12" sm="12">
                        <v-data-table :search="obSearch.search" :headers="listGeneral.listCabecera" id="tableInf"
                            :items="listGeneral.listDetalle" class="elevation-3">
                            
                            <template v-slot:item.valorPagado="{ item }">
                                {{ `${Number.parseFloat(item.valorPagado).toFixed(2)}` }}
                            </template>
                            
                            <template v-slot:item.diaGestion="{ item }">
                                <span :class="item.diff ? 'red--text' : 'black--text'" v-html="item.diaGestion"></span>
                            </template>

                            <template v-slot:item.name="{ item }">
                                <v-btn class="ma-2" text icon color="primary" @click="ver(item)">
                                    <v-icon small>visibility</v-icon>
                                </v-btn>
                            </template>

                            <template v-slot:no-results>
                                Tu búsqueda de "<span v-html="obSearch.search"></span>" no arrojó resultados.
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: 'InformeSiniestroView',
        components:{
            ModalInformeSiniestroComponent: () => import('@/components/siniestro/ModalInformeSiniestroComponent.vue')
        },
        data: () => ({
            obDate:{
                open1:false,
                open2:false
            },
            obSearch:{
                opcion:'LISTAR',
                fechaDesde:moment().format('YYYY-MM-DD'),
                fechaHasta:moment().format('YYYY-MM-DD'),
                idEstadoSiniestro:null,
                nroDocumento:null,
                nombres:null,
                search:''
            },
            obModal:{
                titulo:'Información Siniestro',
                open:false
            },
            listGeneral:{},
            listDocumentos:[],
            parametros:{},
            disabled:false
        }),
        created(){
            var error = 'E';

            axios.post(`${BASE_URI}administrador/informe-siniestro/cargaGeneral`)
                 .then((r)=>{
                    if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                    if(_.size(_.get(r,['data','data'],[])) == 0){ error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);}
                        this.$set(this,'listGeneral',r.data.data.listas);
                        this.$set(this,'parametros',r.data.data.parametros);
                        this.obSearch.idEstadoSiniestro = this.listGeneral.listEstadoSiniestro[0].idEstadoSiniestro;
                        return this.onListar('L');
                 })
                 .catch((e)=>{
                     mensajesAlerta(e,error);
                 });
        },
        methods:{
            onListar(event){
                if(!_.isUndefined(event)){
                    var o = _.cloneDeep(this.obSearch);
                    var error = 'I';
                    o.idEstadoSiniestro = _.get(o,'idEstadoSiniestro',0) != 0 ? o.idEstadoSiniestro : null;

                    axios.post(`${BASE_URI}administrador/informe-siniestro/listar`,_.omit(o,'search'))
                         .then((r)=>{
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if(_.size(_.get(r,['data','data'],[])) == 0){ error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);}
                                var l = _.cloneDeep(r.data.data);
                                l = _.map(l,(v)=>{
                                    v.diff = v.diaGestion > v.siniestro_dias_gestion ? true : false;
                                    return v;
                                });

                                this.$set(this.listGeneral,'listDetalle',l);
                        })
                        .catch((e)=>{
                            mensajesAlerta(e,error);
                        });
                }
            },
            ver(v){
                var error = 'E';
                var o = {
                    opcion:'LISTAR_DETALLE',
                    idSiniestro:v.nroSiniestro,
                    verDetalle:true
                }

                axios.post(`${BASE_URI}administrador/informe-siniestro/listar`,o)
                    .then((r)=>{
                        if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                        if(_.size(_.get(r,['data','data'],[])) == 0){ error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);}
                            var ob = _.get(_.cloneDeep(r.data.data),['0','data'],{});
                            var l = _.get(_.cloneDeep(r.data.data),['0','listDocumentos'],{});

                            l = _.map(l,(v)=>{
                                return {
                                    path: v,
                                    title: _.last(_.split(v,'/')),
                                    iconClass: 'blue white--text',
                                    icon: 'assignment'
                                }
                            });

                            this.$set(this,'obModal',_.merge({},this.obModal,ob,{open:true}));
                            this.$set(this,'listDocumentos',l);
                    })
                    .catch((e)=>{
                        mensajesAlerta(e,error);
                    });
            },
            close(){
                this.obModal = {
                    titulo:'Información Siniestro',
                    open:false
                }
            }
        },
        provide(){
            return{
                close:this.close
            }
        }
    }
</script>